var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { Button } from '../Button/index.js';
export const TopBarButton = (_a) => {
    var { children, variant = 'outline' } = _a, rest = __rest(_a, ["children", "variant"]);
    return (React.createElement(Button, Object.assign({ variant: variant, rounded: true, className: clsx('w-10 h-10 px-0 justify-center flex-shrink-0') }, rest), children));
};
//# sourceMappingURL=TopBarButton.js.map